import { Requestor, StorageBackend } from '@openid/appauth';
import { NgModule, NgZone } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Platform } from '@ionic/angular';

import { authFactory } from './factories';
import { Browser, AuthService } from 'ionic-appauth';
import { CapacitorBrowser, CapacitorStorage } from 'ionic-appauth/lib/capacitor';
import { NgHttpService } from './ng-http.service';

@NgModule({
  imports: [CommonModule],
  providers: [
    {
      provide: StorageBackend,
      useClass: CapacitorStorage,
    },
    {
      provide: Requestor,
      useClass: NgHttpService,
    },
    {
      provide: Browser,
      useClass: CapacitorBrowser,
    },
    {
      provide: AuthService,
      useFactory: authFactory,
      deps: [Platform, NgZone, Requestor, Browser, StorageBackend],
    },
  ],
})
export class MobileOAuthModule {}
